var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ob-admin-section',{attrs:{"type":_vm.type,"xlsx":true,"relatedItems":_vm.relatedItems}},[_c('template',{slot:"section-title"},[_vm._v("Sectiune Liste APL-uri")]),_c('template',{slot:"toolbar-title"},[_vm._v("Baza de date Liste APL-uri")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }